module.exports = __webpack_public_path__ + "static/media/hand-coin-fill.230aa210.svg";